<script>
import { layoutComputed } from "@/state/helpers";

import Vertical from "./vertical";
import Horizontal from "./horizontal";
import TwoColumns from "./twocolumn";
import SystemBanner from "@/components/system-banner.vue";
import { ABILITY_TOKEN } from '@casl/vue';
import Swal from "sweetalert2";
import axios from "axios";

export default {
    inject: {
        $ability: { from: ABILITY_TOKEN }
    },
    components: {
        Vertical,
        Horizontal,
        TwoColumns,
        SystemBanner
    },
    props: {
        module: {
            type: String
        }
    },
    data() {
        return {
            rules: this.$store.state.rules,
            hasPermission: true,
            idleTimer: null,
        };
    },
    methods: {
        testFunction() {
            console.log('timeoutsss');
        },
        resetTimer() {
            clearTimeout(this.idleTimer);
            this.idleTimer = null;
            this.idleTimer = setTimeout(this.testFunction, 5000);
        },
        initializeIdleTimer() {
            // let counterInstance;

            
            // function 

            // window.addEventListener('load', this.resetTimer, true);
            // window.addEventListener('mousemove', this.resetTimer, true);
            // window.addEventListener('mousedown', this.resetTimer, true);
            // window.addEventListener('touchstart', this.resetTimer, true);
            // window.addEventListener('touchmove', this.resetTimer, true);
            // window.addEventListener('click', this.resetTimer, true);
            // window.addEventListener('keydown', this.resetTimer, true);
            // window.addEventListener('scroll', this.resetTimer, true);
            // window.addEventListener('wheel', this.resetTimer, true);
        },
        logout() {
            localStorage.clear();
            this.$router.push({ name: 'login' });
        },
        checkPageAccess() {
            if (!this.$store.state.userRoles.includes(1)) {
                this.hasPermission = false;

                if (this.rules) {
                    this.rules.some(rule => {
                        if (this.$ability.can(rule.action, this.module)) {
                            this.hasPermission = true;
                        }

                        return this.hasPermission;
                    });
                }
            }
            
            if (!this.hasPermission) {
                Swal.fire({
                    title: "Access denied!",
                    text: "You do not have permission on this module.",
                    icon: "error",
                    confirmButtonColor: "#34c38f",
                    cancelButtonColor: "#f46a6a",
                    confirmButtonText: "Ok",
                }).then(() => {
                    this.$router.go(-1);
                });
            }
        },
        /**
         * Signs out a user the server no longer has. Only an answer that says so counts:
         * a failed check (network, rate limit, server error) isn't a reason -- and an
         * expired token (401) is renewed and the check sent again (App.vue), the user
         * signed out only if it can't be. (axios's global handler hands failures back as
         * results, so they are told apart here.)
         */
        async checkTokenExpired() {
            const userId = localStorage.getItem('userid');
            if (!userId) return;

            const result = await axios.get(`${process.env.VUE_APP_AUTHDOMAIN}/api/v1/users/${userId}`).catch(e => e);
            const failed = result && (result.isAxiosError || result instanceof Error);
            // The user no longer exists.
            if (failed && result.response?.status === 404) {
                this.logout();
                return;
            }
            if (failed) {
                console.warn('Session check skipped:', result.response?.status || result.message);
                return;
            }
            if (result?.status === 200 && result.data && !result.data.data) {
                this.logout();
            }
        },
    },
    computed: {
        ...layoutComputed
    },
    mounted() {
        this.checkTokenExpired();

        if (this.module) {
            this.checkPageAccess();
        }

        // initialize idle timer
        //this.initializeIdleTimer();
    },
    beforeUnmount() {
        console.log('leaving');
        //if (this.idleTimer) {
            //clearTimeout(this.idleTimer);
            //this.idleTimer = null;
        //}
    }
};
</script>

<template>
    <div>
        <Vertical v-if="layoutType === 'vertical' || layoutType === 'semibox'" :layout="layoutType">
            <!-- Announcements, the maintenance notice and the idle sign-out (System Configuration). -->
            <SystemBanner />
            <slot v-if="hasPermission" />
        </Vertical>

        <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
            <SystemBanner />
            <slot v-if="hasPermission"/>
        </Horizontal>

        <TwoColumns v-if="layoutType === 'twocolumn'" :layout="layoutType">
            <SystemBanner />
            <slot v-if="hasPermission"/>
        </TwoColumns>
    </div>
</template>
